<template>
  <div>
    <edit-modal
            ref="editResultModal"
            v-on:editName="updateRow">
    </edit-modal>

    <delete-modal
            ref="deleteResultModal"
            v-on:deleted="removeRow">
    </delete-modal>

    <p>
      Gesamt: {{ this.items.length }}
    </p>

    <b-input-group class="mb-2">
      <b-input v-model="filter" placeholder="Suchen..."></b-input>
      <b-input-group-append>
        <b-btn :disabled="!filter" @click="filter=''">Filter löschen</b-btn>
      </b-input-group-append>
    </b-input-group>
    <b-table
            :fields="this.fields"
            :items="this.items"
            :filter="this.filter"
            responsive>

      <template v-slot:cell(type)="row">
        <span v-if="row.item.type === 'online'">online</span>
        <span v-else>papierbasiert</span>
      </template>

      <template v-slot:cell(code)="row">
        <span v-if="row.item.type === 'online'" style="font-family: 'Courier New', serif;">{{ row.value | uppercase }}</span>
        <span v-else>-</span>
      </template>

      <template v-slot:cell(started)="row">
        <span v-if="row.item.type === 'online'" :title="row.value">
          {{ row.value | moment('calendar')}}
        </span>
        <span v-else>-</span>
      </template>

      <template v-slot:cell(finished)="row">
        <span v-if="row.item.type === 'paper'">-</span>
        <span v-else-if="row.value">ja</span>
        <span v-else>nein</span>
      </template>

      <template v-slot:cell(points)="row">
        <span v-if="row.item.finished" :title="row.value">{{ row.value }}</span>
        <span v-else>-</span>
      </template>

      <template v-slot:cell(buttons)="row">
        <b-button variant="danger" size="sm" v-b-tooltip.hover title="Löschen" v-on:click="del(row.item.token)">
          <font-awesome-icon icon="trash-alt"></font-awesome-icon>
        </b-button>

        <b-button type="button" size="sm" v-b-tooltip.hover title="bearbeiten" v-on:click="edit(row.item.token)">
          <font-awesome-icon icon="edit"></font-awesome-icon>
        </b-button>
      </template>
    </b-table>
  </div>
</template>
<script>
import EditResultModal from '@/components/competitions/results/EditResultModal'
import DeleteResultModal from '@/components/competitions/results/DeleteResultModal'
import Paper from '@/components/competitions/details/Paper'

export default {
  name: 'ResultsTableOnline',
  props: ['competition', 'registration', 'reload'],
  components: {
    editModal: EditResultModal,
    deleteModal: DeleteResultModal,
    Paper
  },
  data: function () {
    return {
      filter: '',
      reloadResults: null,
      fields: [
        {key: 'name', label: 'Name', sortable: true},
        {key: 'age', label: 'Klassenstufe', sortable: true},
        {key: 'type', label: 'Teilnahme', sortable: true},
        {key: 'points', label: 'Punkte', sortable: true},
        {key: 'code', label: 'Verwendeter Code'},
        {key: 'started', label: 'Begonnen', sortable: true},
        {key: 'finished', label: 'Beendet'},
        {key: 'buttons', label: ''}
      ],
      items: []
    }
  },

  mounted: function () {
    this.load()
    if (!this.reloadResults && this.competition.onlineStarted() && !this.competition.onlineEnded()) {
      this.reloadResults = setInterval(this.load, 10 * 1000)
    }
  },

  beforeDestroy () {
    if (this.reloadResults) {
      clearInterval(this.reloadResults)
    }
  },

  methods: {
    del: function (token) {
      this.$refs.deleteResultModal.show(token)
    },

    edit: function (token) {
      const index = this.items.findIndex(e => e.token === token)
      const row = this.items[index]

      if (row.type === 'online') {
        this.$refs.editResultModal.show(token, row.name, row.age)
      } else {
        this.$emit('editResult', row)
      }
    },

    updateRow: function (token, data) {
      const index = this.items.findIndex(e => e.token === token)
      this.items[index].name = data.name
      this.items[index].age = data.age
    },

    removeRow: function (token) {
      const index = this.items.findIndex(e => e.token === token)
      this.$delete(this.items, index)
    },

    load: function () {
      if (document.hidden) {
        console.log('skipped reload (document.hidden)')
        return
      }

      this.axios.get('competitions/' + this.competition.id + '/schools/' + this.registration.schoolId + '/results')
        .then((rsp) => this.$set(this, 'items', rsp.data))
        .catch((err) => {
          if (!err.status) {
            clearInterval(this.reloadResults)
            this.$eventHub.$emit('error', 'Beim Laden der Ergebnisse kam es zu einem Netzwerkfehler. Bitte prüfen Sie ihre Internetverbingung und laden Sie die Seite erneut.')
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/results/ResultsTable.vue